module.exports = __webpack_public_path__ + "img/compact.8ae6a80d.png";